/**
 * @param {DeliveryTime[]} deliveryTimes
 * @param {number} amount
 * @param {boolean} isRush
 * @param {boolean} isOffset
 * */
export const findDeliveryTimeForAmount = (deliveryTimes, amount, isRush, isOffset) => {
	return deliveryTimes
		.filter(dt => dt.productionSpeed === (isRush ? "rush" : "standard")
			&& dt.productionType === (isOffset ? "offset" : "standard")
			&& dt.fromQuantity <= (!amount ? 1 : amount))
		.sort((a, b) => b.fromQuantity - a.fromQuantity)[0];
};



// WEBPACK FOOTER //
// ./src/helpers/findDeliveryTimeForAmount.js